import ProductTabsPresenter from "../components/product-tabs/presenter/product-tabs.js";

const toPropertiesButton = document.querySelector(`.product-to-properties-list_product-title`);
const listElement = document.querySelector(`.product-navigation__list`);

const productTabsComponent = new ProductTabsPresenter(listElement, toPropertiesButton);
productTabsComponent.init();
